export default __webpack_public_path__ + "static/la-splendeur-au-lieu-des-cendres-titre-0221f24fe3865315b273f4b4df98e9c1.webp";